import axios, { AxiosInstance } from 'axios';
import { Config } from '@/utils/Config';

export abstract class BaseServiceDefinition {
    private axiosInstance: AxiosInstance;

    constructor() {
        this.axiosInstance = axios.create();
    }

    get(url: string): Promise<any> {
        return this.axiosInstance.get(Config.apiBaseUrl + url);
    }

    post(url: string, data?: any): Promise<any> {
        return this.axiosInstance.post(Config.apiBaseUrl + url, data);
    }
}